import { modifier } from 'ember-modifier';

export default modifier((_element: Element, [enabled = true]: [boolean?]) => {
  if (!enabled) {
    return;
  }

  if (window.Intercom) {
    // @ts-expect-error - Intercom is not typed
    window.Intercom('update', { hide_default_launcher: true });
  }

  return () => {
    if (window.Intercom) {
      // @ts-expect-error - Intercom is not typed
      window.Intercom('update', { hide_default_launcher: false });
    }
  };
});
